/**
 * Show Text and CTA sections only after Octane AI quiz results are displayed.
 * Quiz questions and results share the same page URL; visibility is driven by DOM state.
 */
(function () {
  'use strict';

  var QUIZ_ROOT_SEL = '.octane-ai-quiz-rendered, #octane-quiz-outer-wrapper';
  var CTA_MARKER_SEL = '[data-quiz-result-cta="true"]';
  var VISIBLE_CLASS = 'is-quiz-result-visible';

  function getQuizRoot() {
    return document.querySelector(QUIZ_ROOT_SEL);
  }

  function isQuizResultVisible(quizRoot) {
    if (!quizRoot) return false;

    if (
      quizRoot.querySelector(
        '[data-element*="oct-quiz-multiplechoice"], [data-element*="oct-quiz-singlechoice"]'
      )
    ) {
      return false;
    }

    if (
      quizRoot.querySelector(
        '[data-element*="oct-quiz-input"], [data-element*="oct-quiz-submit-btn"], [data-element*="oct-quiz-skip-btn"]'
      )
    ) {
      return false;
    }

    return !!quizRoot.querySelector('[data-element*="oct-quiz-productblock"]');
  }

  function updateCtaSections() {
    var quizRoot = getQuizRoot();
    var show = isQuizResultVisible(quizRoot);
    var markers = document.querySelectorAll(CTA_MARKER_SEL);

    for (var i = 0; i < markers.length; i++) {
      var section = markers[i].closest('.shopify-section');
      if (section) {
        section.classList.toggle(VISIBLE_CLASS, show);
      }
    }
  }

  function observeQuiz(quizRoot) {
    if (!quizRoot || quizRoot.getAttribute('data-quiz-result-cta-bound') === '1') return;
    quizRoot.setAttribute('data-quiz-result-cta-bound', '1');

    var observer = new MutationObserver(function () {
      if (!quizRoot.isConnected) {
        observer.disconnect();
        return;
      }
      updateCtaSections();
    });

    observer.observe(quizRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-element', 'data-display'],
    });

    updateCtaSections();
  }

  function tryBindQuiz() {
    var quizRoot = getQuizRoot();
    if (quizRoot) {
      observeQuiz(quizRoot);
      return;
    }
    updateCtaSections();
  }

  function start() {
    tryBindQuiz();

    var scheduled = false;
    function scheduleCheck() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        tryBindQuiz();
      });
    }

    new MutationObserver(scheduleCheck).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
